import { render } from "./pointsLabel.vue?vue&type=template&id=9e59b2aa&scoped=true&ts=true"
import script from "./pointsLabel.vue?vue&type=script&lang=ts"
export * from "./pointsLabel.vue?vue&type=script&lang=ts"

import "./pointsLabel.vue?vue&type=style&index=0&id=9e59b2aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e59b2aa"]])

export default __exports__